export * from './promotion.types';

import type { IPromotion, IPromotionData } from '@/entities';

export class Promotion implements IPromotion {
  id = '';
  header = '';
  description = '';
  imageUrl = '';
  startDateTime = new Date();
  endDateTime = new Date();
  primaryAction?: 'GO_TO_COURSE' | 'GO_TO_URL';
  primaryActionUrl?: string; // lo id
  primaryButtonLabel?: string;
  secondaryAction?: string;
  secondaryActionUrl?: string; // url
  secondaryButtonLabel?: string;
  winner?: {
    details: string;
    firstName: string;
    imageUrl: string;
    lastName: string;
    userId: number;
  };

  constructor(data: IPromotionData) {
    Object.assign(this, data);
  }
}
